import CostCentre from "../../../utils/services/project/accounting/costCentreService";
import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
let crud = crudTemplate(CostCentre);
let roles = rolesTemplate(CostCentre);

function prepareItem(item) {
  item.group_id = item._group && item._group.id;
  item._groups = item._group
    ? [...(item._group._ancestors || []), item._group]
    : [];
  item._group = item._group || {};
  return item;
}
const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  }
};

const actions = {
  ...crud.actions,
  ...roles.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item._group = { id: item.group_id };
    return crud.actions.create(_, {
      item,
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
